<template>
  <div
    class="bigdata_container"
    id="bigdata"
    v-loading="isLoading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="header">走访探视可视化平台</div>
    <div class="quanp">
      <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
        onFullScreen ? "退出全屏" : "进入全屏"
      }}</el-button>
    </div>
    <div class="bigdata_main">
      <el-row :gutter="20">
        <el-col :span="3">
          <div style="width:100%;background:red;">1</div>
        </el-col>
        <el-col :span="3"></el-col>
        <el-col :span="9"></el-col>
        <el-col :span="9"></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request.js";
export default {
  name: "visualized",
  data() {
    return {
      isLoading: false,
      onFullScreen: false, // 是否全屏
    };
  },
  filters: {
    //时间格式化
    formatDate(date) {
      let dt = new Date(date);
      let dty = dt.getFullYear();
      let dtm = (dt.getMonth() + 1).toString().padStart(2, "0");
      let dtd = dt.getDate().toString().padStart(2, "0");
      let dth = dt.getHours().toString().padStart(2, "0");
      let dtmi = dt.getMinutes().toString().padStart(2, "0");
      let dts = dt.getSeconds().toString().padStart(2, "0");
      return dty + "-" + dtm + "-" + dtd;
    },
  },
  methods: {
    // 控制全屏展示
    showFullScreen() {
      this.onFullScreen = !this.onFullScreen;
      if (this.onFullScreen) {
        this.FullCreeen();
      } else {
        //退出全屏,三目运算符
        document.exitFullscreen
          ? document.exitFullscreen()
          : document.mozCancelFullScreen
          ? document.mozCancelFullScreen()
          : document.webkitExitFullscreen
          ? document.webkitExitFullscreen()
          : "";
      }
    },
    FullCreeen(element) {
      let el = document.getElementById("bigdata");
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nameoftransition-enter-active,
.nameoftransition-leave-active {
  transition: opacity 0.5s;
}
.nameoftransition-enter,
.nameoftransition-leave-to {
  opacity: 0;
}
//引入的字体样式
@font-face {
  font-family: "Unidtrsmled";
  src: url(./assets/font/UnidreamLED.ttf);
}
/deep/ .el-carousel__container {
  height: 100% !important;
  .el-icon-arrow-left:before,
  .el-icon-arrow-right:before {
    color: #489aff;
    font-weight: bold;
    font-size: 22px;
  }
}
.update_info {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  top: 50px;
  color: #ffffff;
  font-size: 14px;
  .info_left {
    overflow-y: scroll;
    width: 50%;
    padding: 0 12px;
    &::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
    }
    .left_title {
      display: flex;
      span {
        flex: 1;
        line-height: 24px;
        &:nth-child(1) {
          flex: 0 0 60px;
        }
      }
    }
    .left_list {
      display: flex;
      .list_item {
        flex: 1;
        line-height: 48px;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        .index {
          border-radius: 50%;
          height: 24px;
          width: 26px;
          background: #489aff;
          text-align: center;
          font-size: 14px;
          line-height: 24px;
          font-family: Unidtrsmled;
        }
      }
    }
  }
  .info_right {
    width: 50%;
    padding: 0 12px;
    .wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      .left {
        margin-right: 12px;
      }
      .label {
        margin-bottom: 12px;
        color: #489aff;
      }
    }
  }
}

.bigdata_container {
  position: relative;
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  background: url("./assets/img/bg.png") no-repeat center center;
  background-size: 100% 100%;
  .info_tisp {
    min-width: 380px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #ebeef5;
    position: fixed;
    left: 50%;
    top: 20px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color: #edf2fc;
    border-radius: 5px;
    -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
    transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
    transition: opacity 0.3s, transform 0.4s, top 0.4s;
    transition: opacity 0.3s, transform 0.4s, top 0.4s, -webkit-transform 0.4s;
    padding: 15px;
    display: flex;
    align-items: center;
    line-height: 1;
    .el-message__icon {
      margin-right: 10px;
    }
  }
  .header {
    margin: auto;
    width: 90%;
    height: 100px;
    background: url("./assets/img/bg_header.png") no-repeat center center;
    background-size: 100%;
    text-align: center;
    line-height: 73px;
    color: #1ad4f0;
    font-size: 25px;
  }
  .bigdata_main {
    position: absolute;
    left: 0;
    top: 100px;
    right: 0;
    bottom: 0;
  }
  .quanp {
    width: 200px;
    height: 100px;
    float: right;
    position: absolute;
    top: 20px;
    right: -110px;
    z-index: 100;
    button {
      padding: 10px;
    }
  }
}
</style>
